import { Link } from 'react-router-dom';
import { Moon, Sun, Users } from 'lucide-react';
import { LoginArea } from '@/components/auth/LoginArea';
import { useTheme } from '@/hooks/useTheme';
import { Button } from '@/components/ui/button';

export function SiteHeader() {
  const { theme, setTheme } = useTheme();
  // Resolve what the visitor actually sees (system → OS preference),
  // so the icon always shows the *opposite* of the current appearance.
  const isDark =
    theme === 'dark' ||
    (theme === 'system' &&
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-color-scheme: dark)').matches);

  return (
    <header className="sticky top-0 z-40 border-b bg-background/85 backdrop-blur">
      <div className="container flex h-16 items-center justify-between gap-3">
        <Link to="/" className="flex items-center gap-2.5" aria-label="Follow Party home">
          <span className="grid size-9 place-items-center rounded-xl bg-primary text-primary-foreground">
            <Users className="size-5" aria-hidden />
          </span>
          <span className="leading-none">
            <span className="block font-display text-2xl tracking-tight">Follow Party</span>
            <span className="block text-[11px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
              Nostr follow packs
            </span>
          </span>
        </Link>

        <nav className="flex items-center gap-2">
          <Button variant="ghost" size="icon" aria-label="Toggle theme" title="Toggle light / dark" onClick={() => setTheme(isDark ? 'light' : 'dark')}>
            {isDark ? <Sun className="size-4" /> : <Moon className="size-4" />}
          </Button>
          <LoginArea className="max-w-56" />
        </nav>
      </div>
    </header>
  );
}

export function SiteFooter() {
  return (
    <footer className="border-t py-8">
      <div className="container flex flex-col items-center justify-between gap-3 text-sm text-muted-foreground sm:flex-row">
        <p>
          <span className="font-display text-lg text-foreground">Follow Party</span>{' '}
          — curated follow packs for Nostr. Compatible with kind 39089 packs.
        </p>
        <p>
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noreferrer"
            className="underline decoration-accent decoration-2 underline-offset-4 hover:text-foreground"
          >
            Vibed with Shakespeare
          </a>
        </p>
      </div>
    </footer>
  );
}
